export const UNREAD_COUNT_QUERY_KEY = [
  'notifications',
  'unread-count',
] as const;
export const NOTIFICATIONS_LIST_QUERY_KEY = ['notifications', 'list'] as const;
